import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Calendar, User, Search } from 'lucide-react';
import { useCustomers, useEvents } from '@/hooks/useFirebaseQueries';
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command';

interface GlobalSearchProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const GlobalSearch = ({ open, onOpenChange }: GlobalSearchProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const { data: customers = [] } = useCustomers();
  const { data: events = [] } = useEvents();

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        onOpenChange(!open);
      }
    };

    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, [open, onOpenChange]);

  const onSelect = (path: string) => {
    onOpenChange(false);
    navigate(path);
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Escribe un comando o busca..." />
      <CommandList>
        <CommandEmpty>No se encontraron resultados.</CommandEmpty>
        
        <CommandGroup heading="Clientes">
          {customers.slice(0, 10).map((customer) => (
            <CommandItem
              key={customer.id}
              value={customer.name + ' ' + (customer.email || '') + ' ' + customer.id}
              onSelect={() => onSelect(`/customers/${customer.id}`)}
            >
              <User className="mr-2 h-4 w-4" />
              <span>{customer.name}</span>
            </CommandItem>
          ))}
        </CommandGroup>
        
        <CommandGroup heading="Eventos">
          {events.slice(0, 10).map((event) => (
            <CommandItem
              key={event.id}
              value={event.title + ' ' + event.id}
              onSelect={() => onSelect(`/events/${event.id}`)}
            >
              <Calendar className="mr-2 h-4 w-4" />
              <span>{event.title || t('events.untitled')}</span>
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
};

export default GlobalSearch;
